import {HTMLAttributes} from 'react';
import {getCompareAvgLevel} from '@/map/utils';

interface IProps extends HTMLAttributes<HTMLImageElement> {
  total?: number;
  avg?: number;
}

const getIcon = (level: number) => {
  return require(`./assets/level${level}.svg`);
};

export const CompareAvgIcon = ({total, avg, ...props}: IProps) => {
  if (!total || !avg) {
    return null;
  }

  const level = getCompareAvgLevel(total, avg);

  return <img src={getIcon(level)} alt={`level ${level}`} {...props} />;
};
